import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d0c178c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-viewer-controller has-background-contents" }
const _hoisted_2 = { class: "is-sr-only" }
const _hoisted_3 = { class: "image-viewer-controller-size" }
const _hoisted_4 = { class: "image-processing-note-emphasis" }
const _hoisted_5 = { class: "level is-mobile" }
const _hoisted_6 = { class: "has-text-table-cell-title has-text-modest" }
const _hoisted_7 = { class: "image-viewer-controller-actions level-right" }
const _hoisted_8 = { class: "image-viewer-controller-size-degree" }
const _hoisted_9 = {
  id: "image-viewer-controller-size-degree-label",
  class: "has-text-table-item-name"
}
const _hoisted_10 = { class: "level-left" }
const _hoisted_11 = { class: "image-viewer-controller-size-degree-input level" }
const _hoisted_12 = { class: "image-viewer-controller-size-cut" }
const _hoisted_13 = { class: "has-text-table-item-name" }
const _hoisted_14 = { class: "level is-mobile" }
const _hoisted_15 = { class: "level is-mobile" }
const _hoisted_16 = {
  key: 0,
  id: "cropping-size-select-area",
  class: "level is-mobile cropping-size-select-area"
}
const _hoisted_17 = { class: "level is-mobile cropping-size-input-area" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" × ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" mm ")
const _hoisted_20 = { class: "image-viewer-controller-size-div" }
const _hoisted_21 = { class: "has-text-table-item-name" }
const _hoisted_22 = { class: "level-left is-mobile" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" × ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_AutoClipToggleSwitch = _resolveComponent("AutoClipToggleSwitch")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_AddonViewProcessingColor = _resolveComponent("AddonViewProcessingColor")!
  const _component_TwoInOneCoverPageToggleSwitch = _resolveComponent("TwoInOneCoverPageToggleSwitch")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('rightPane.processing')), 1),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('rightPane.imageProcessingNotes1')) + " ", 1),
        _createElementVNode("em", _hoisted_4, _toDisplayString(_ctx.$t('rightPane.imageProcessingNotes2')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('rightPane.imageProcessingNotes3')), 1)
      ]),
      _createElementVNode("header", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('rightPane.size')), 1),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_AppButton, {
            id: "reset-processing-size-button",
            class: "reset-processing-size-button",
            styled: "is-none has-text-link",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.resetSizeProcessing()), ["prevent"])),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.resetSizeProcessing()), ["prevent"]), ["space","enter"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('rightPane.resetSize')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('rightPane.kakudo')), 1),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _createVNode(_component_AppInput, {
                min: -360,
                max: 360,
                modelValue: _ctx.currentDegree,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentDegree) = $event)),
                type: "number",
                "aria-labelledby": "image-viewer-controller-size-degree-label",
                id: "degree-input-area"
              }, null, 8, ["modelValue"]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('rightPane.do')), 1)
            ])
          ]),
          _createVNode(_component_ButtonIcon, {
            text: _ctx.$t('rightPane.left90'),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.rotateImage(-90))),
            onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.rotateImage(-90)), ["prevent"]), ["space","enter"])),
            type: "button",
            icon: "rotate-left",
            id: "rotate-left-button"
          }, null, 8, ["text"]),
          _createVNode(_component_ButtonIcon, {
            text: _ctx.$t('rightPane.right90'),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.rotateImage(90))),
            onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.rotateImage(90)), ["prevent"]), ["space","enter"])),
            type: "button",
            icon: "rotate-right",
            id: "rotate-right-button"
          }, null, 8, ["text"])
        ])
      ]),
      _createVNode(_component_AutoClipToggleSwitch),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('rightPane.selectRangeImageSearch')), 1),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_AppButton, {
            class: _normalizeClass({'cropping-mode-start-botton': !_ctx.croppingModeFlag, 'cropping-mode-stop-botton': _ctx.croppingModeFlag }),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeCroppingMode())),
            onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.changeCroppingMode()), ["prevent"]), ["space","enter"])),
            styled: {'is-normal': !_ctx.croppingModeFlag, 'is-accent': _ctx.croppingModeFlag},
            "aria-expanded": _ctx.croppingModeFlag,
            "aria-controls": "cropping-size-select-area"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.croppingModeFlag ? _ctx.$t('rightPane.doneSelect') : _ctx.$t('rightPane.selectRage')), 1)
            ]),
            _: 1
          }, 8, ["class", "styled", "aria-expanded"]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_AppButton, {
              id: "image-viewer-crop-botton",
              disabled: !_ctx.croppingModeFlag,
              onClick: _ctx.cropWithCurrentArea,
              onKeydown: _withKeys(_withModifiers(_ctx.cropWithCurrentArea, ["prevent"]), ["space","enter"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('rightPane.cut')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick", "onKeydown"]),
            _createVNode(_component_AppButton, {
              id: "image-viewer-search-image-botton",
              disabled: !_ctx.croppingModeFlag,
              onClick: _ctx.searchImage,
              onKeydown: _withKeys(_withModifiers(_ctx.searchImage, ["prevent"]), ["space","enter"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('rightPane.imageSearch')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick", "onKeydown"])
          ])
        ]),
        (_ctx.croppingModeFlag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_AppSelect, {
                id: "cropping-size-select-box",
                modelValue: _ctx.croppingSizeTextValue,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.croppingSizeTextValue) = $event)),
                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeCroppingSize($event.target.value))),
                styled: "is-normal",
                options: _ctx.printSizeLocale
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_AppInput, {
                  id: "cropping-size-input-width",
                  modelValue: _ctx.selectionRangeWidth,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectionRangeWidth) = $event)),
                  type: "number",
                  label: _ctx.$t('label.widthRange')
                }, null, 8, ["modelValue", "label"]),
                _hoisted_18,
                _createVNode(_component_AppInput, {
                  id: "cropping-size-input-height",
                  modelValue: _ctx.selectionRangeHeight,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectionRangeHeight) = $event)),
                  type: "number",
                  label: _ctx.$t('label.verticalWidthRange')
                }, null, 8, ["modelValue", "label"]),
                _hoisted_19
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('rightPane.separate')), 1),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", null, [
            _createVNode(_component_AppInput, {
              id: "division-size-input-X",
              modelValue: _ctx.currentDivisionHorizontal,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentDivisionHorizontal) = $event)),
              type: "number",
              label: _ctx.$t('label.divisionsHorizontal'),
              min: _ctx.divisionRange.min,
              max: _ctx.divisionRange.max
            }, null, 8, ["modelValue", "label", "min", "max"]),
            _hoisted_23,
            _createVNode(_component_AppInput, {
              id: "division-size-input-Y",
              modelValue: _ctx.currentDivisionVertical,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.currentDivisionVertical) = $event)),
              type: "number",
              label: _ctx.$t('label.divisionsVertical'),
              min: _ctx.divisionRange.min,
              max: _ctx.divisionRange.max
            }, null, 8, ["modelValue", "label", "min", "max"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AddonViewProcessingColor, {
      onOnClickAutoAdjust: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('onClickAutoAdjust')))
    }),
    _createVNode(_component_TwoInOneCoverPageToggleSwitch)
  ]))
}